module.exports = __webpack_public_path__ + "img/tss-8.168f515a.jpg";